import API from "../../admin/apis/index";

export default {
  CreateAgreement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.createAgreement(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetAgreement({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.getAgreement(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  UpdateAgreement({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.updateAgreement(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  geteSignRequest({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.geteSignRequest(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  geteSignWidget({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.geteSignWidget(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getHeadingsPages({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await API.agreement.getHeadingsPages(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
